<template>
  <div class="flex justify-between space-x-3">
    <div
      id="chart"
      :style="{ backGround: bg_line }"
      class="w-1/4 shadow-xs rounded pt-1"
    >
      <apexchart
        type="bar"
        class="w-11/12"
        height="180"
        :options="thisWeekOptions"
        :series="thisWeekSeries"
      ></apexchart>
    </div>

    <div
      id="chart"
      :style="{ backGround: bg_line }"
      class="w-1/4 shadow-xs rounded pt-1"
    >
      <apexchart
        type="bar"
        class="w-11/12"
        height="180"
        :options="lastWeekOptions"
        :series="lastWeekSeries"
      ></apexchart>
    </div>

    <div
      id="chart"
      :style="{ backGround: bg_line }"
      class="w-1/4 shadow-xs rounded pt-1"
    >
      <apexchart
        type="bar"
        class="w-11/12"
        height="180"
        :options="thisMonthOptions"
        :series="thisMonthSeries"
      ></apexchart>
    </div>

    <div
      id="chart"
      :style="{ backGround: bg_line }"
      class="w-1/4 shadow-xs rounded pt-1"
    >
      <apexchart
        type="bar"
        class="w-11/12"
        height="180"
        :options="thisYearOptions"
        :series="thisYearSeries"
      ></apexchart>
    </div>
  </div>
</template>

<script>
export default {
  name: "BarCharts",

  props: {
    bg_line: String,
    bg_text: String,
    thisWeekData: Object,
    lastWeekData: Object,
    thisMonthData: Object,
    thisYearData: Object,
  },

  data() {
    return {
      thisWeekSeries: [
        {
          name: "Success",
          data: this.thisWeekData.success,
        },
        {
          name: "Failed",
          data: this.thisWeekData.failed,
        },
      ],

      thisWeekOptions: {
        chart: {
          type: "bar",
          foreColor: "#7777bb",
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            startingShape: "flat",
            endingShape: "rounded",
            columnWidth: "50%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "solid",
        },
        colors: ["#02B80A", "#b30000"],
        xaxis: {
          type: "category",
          categories: ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"],
          labels: {
            style: {
              colors: [],
              fontSize: "11px",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => "₦" + val,
          },
        },
        tooltip: {
          x: {
            format: "dd/MM/yy",
          },
        },
        title: {
          text: "Transactions for This Week",
          floating: false,
          style: {
            fontSize: "11px",
            fontWeight: "light",
            color: this.bg_text,
          },
        },
      },

      lastWeekSeries: [
        {
          name: "Success",
          data: this.lastWeekData.success,
        },
        {
          name: "Failed",
          data: this.lastWeekData.failed,
        },
      ],

      lastWeekOptions: {
        chart: {
          type: "bar",
          foreColor: "#7777bb",
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            startingShape: "flat",
            endingShape: "rounded",
            columnWidth: "50%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "solid",
        },
        colors: ["#3366ff", "#b30000"],
        xaxis: {
          type: "category",
          categories: ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"],
          labels: {
            style: {
              colors: [],
              fontSize: "11px",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => "₦" + val,
          },
        },
        tooltip: {
          x: {
            format: "dd/MM/yy",
          },
        },
        title: {
          text: "Transactions for Last Week",
          floating: false,
          style: {
            fontSize: "11px",
            fontWeight: "light",
            color: this.bg_text,
          },
        },
      },

      thisMonthSeries: [
        {
          name: "Success",
          data: this.thisMonthData.success,
        },
        {
          name: "Failed",
          data: this.thisMonthData.failed,
        },
      ],

      thisMonthOptions: {
        chart: {
          type: "bar",
          foreColor: "#7777bb",
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            startingShape: "flat",
            endingShape: "rounded",
            // columnWidth: '20%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "solid",
        },
        colors: ["#02B80A", "#b30000"],
        xaxis: {
          type: "category",
          categories: this.getThisMonthDays(),
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: true,
            hideOverlappingLabels: false,
            showDuplicates: false,
            trim: true,
            style: {
              colors: [],
              fontSize: "5px",
              // fontWeight: 300,
            },
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => "₦" + val,
          },
        },
        tooltip: {
          x: {
            show: true,
            format: "dd",
            formatter: (name) => {
              return name + " of " + this.moment().format("MMMM");
            },
          },
        },
        title: {
          text: "Transactions for this Month",
          floating: false,
          style: {
            fontSize: "11px",
            fontWeight: "light",
            color: this.bg_text,
          },
        },
      },

      thisYearSeries: [
        {
          name: "Success",
          data: this.thisYearData.success,
        },
        {
          name: "Failed",
          data: this.thisYearData.failed,
        },
      ],

      thisYearOptions: {
        chart: {
          type: "bar",
          foreColor: "#7777bb",
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            startingShape: "flat",
            endingShape: "rounded",
            // columnWidth: '13%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "solid",
        },
        colors: ["#3366ff", "#b30000"],
        xaxis: {
          type: "category",
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: true,
            hideOverlappingLabels: false,
            trim: true,
            style: {
              fontSize: "7px",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => "₦" + val,
          },
        },
        title: {
          text: "Transactions for This Year",
          floating: false,
          style: {
            fontSize: "11px",
            fontWeight: "light",
            color: this.bg_text,
          },
        },
        tooltip: {
          x: {
            show: true,
            format: "dd",
            formatter: (name) => {
              return name + " of " + this.moment().format("YYYY");
            },
          },
        },
      },
    };
  },

  methods: {
    getThisMonthDays() {
      const noOfDays = 31;
      const monthDays = [];
      for (let i = 1; i <= noOfDays; i++) {
        monthDays.push(i);
      }
      return monthDays;
    },
  },
};
</script>
